// extracted by mini-css-extract-plugin
export default {"root":"j_RIhu","button":"lUtTok","delimiter":"AVWVvP"};